import infoModal from '../gateInfo/infoModal.vue'
import gateInfo from '@/components/gateInfo/gateInfo.vue'
import circuitInfo from '@/components/gateInfo/circuitInfo.vue'
import gateInfoBasic from '@/components/gateInfo/gateInfoBasic.vue'
import gateInfoCircuit from '@/components/gateInfo/gateInfoCircuit.vue'
import gateInfoSubCircuit from '@/components/gateInfo/gateInfoSubCircuit.vue'
import gateInfoTooltip from '@/components/gateInfo/gateInfoTooltip'

export {
  infoModal,
  gateInfoTooltip,
  gateInfo,
  circuitInfo,
  gateInfoBasic,
  gateInfoCircuit,
  gateInfoSubCircuit
}
